import { Api, Globals } from 'utils';

class GeneralService {

	static getBanks = async (params = {}) => Api.createResponse('web/general/banks',params,'get');
	// static getBanksOTP = async (params = {}) => Api.createResponse('web/general/syspago/banksotp',params);
	static getConversion = async (params = {}) => Api.createResponse('web/general/conversion',params,'get');
	static getDocumentTypes = async (params = {}) => Api.createResponse('web/general/document-types',params,'get');
	static getMeasuringUnits = async (params = {}) => Api.createResponse('web/general/measuring-units',params,'get');
	static getMedia = async (params = {}) => Api.createResponse('web/general/media',params,'get');
	static getPaymentMethodInfo = async (id: number) => Api.createResponse(`web/general/payment-method-info/${id}`,{},'get');
	static getPaymentMethods = async (params = {}) => Api.createResponse('web/general/payment-methods',params,'get');
	static getPhoneCodes = async (params = {}) => Api.createResponse('web/general/phone-codes',params,'get');
	static getPresentations = async (params = {}) => Api.createResponse('web/general/presentations',params,'get');
	static getSpecialties = async (params = {}) => Api.createResponse('web/general/specialties',params,'get');
	static getAppointmentTypes = async (params = {}) => Api.createResponse('web/general/appointment-types',params,'get');
	static getStates = async (params = {}) => Api.createResponse('web/general/states',params,'get');
	static getQuestions = async (params = {}) => Api.createResponse(`web/general/questions?${Globals.objectToQueryParams(params)}`,{},'get');

}

export default GeneralService;
